module.exports = __webpack_public_path__ + "static/media/Avatar1.dd2329f8.svg";